import createOrmSelector from 'redux/utils/createOrmSelector';

export default createOrmSelector(
  (session) => {
    const { DietanamnezFrequency } = session;

    return DietanamnezFrequency
      .all()
      .toRefArray()
      .map(item => ({
        content: item.custom_частота,
        value: item.key,
      }));
  },
);
